// extracted by mini-css-extract-plugin
export default {"banner":"case-studies--banner--WvIVupvC","frame":"case-studies--frame--ZdCFo9z6","mobileFrame":"case-studies--mobileFrame--zkb5lKNu"};